export default "__VITE_ASSET__Dp6ig_Dw__"